import { QdzElement, define, formatMoney } from '@qdz/element';
import { addItems, openCart } from '@qdz/cart';

export class QdzBoughtTogether extends QdzElement {
  get items() {
    return [...this.querySelectorAll('[data-ref="item"]')];
  }

  mount() {
    this.listen(this, 'change', () => this.update());
    this.listen(this, 'qdz:recommendations:load', () => this.update());
    this.listen(this.ref('add'), 'click', () => this.#add());
    this.listen(document, 'qdz:variant:change', (event) => {
      const select = this.querySelector('.qdz-bundle__item--current select');
      if (select && [...select.options].some((option) => option.value === String(event.detail.variantId))) {
        select.value = String(event.detail.variantId);
        this.update();
      }
    });
    this.update();
  }

  #choice(item) {
    const field = item.querySelector('[data-ref="variant"]');
    const source = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
    return { id: Number(field.value), price: Number(source?.dataset.price || 0), compare: Number(source?.dataset.compare || 0) };
  }

  update() {
    const format = this.getAttribute('money-format') || undefined;
    let count = 0;
    let total = 0;
    let compare = 0;
    for (const item of this.items) {
      const choice = this.#choice(item);
      item.querySelector('[data-ref="price"]').textContent = formatMoney(choice.price, format);
      if (!item.querySelector('[data-ref="check"]').checked) continue;
      count += 1;
      total += choice.price;
      compare += Math.max(choice.compare, choice.price);
    }
    this.ref('count').textContent = (count === 1 ? this.dataset.countOne : this.dataset.countOther).replace('[count]', count);
    this.ref('total').textContent = formatMoney(total, format);
    const struck = this.ref('compare');
    struck.hidden = compare <= total;
    struck.textContent = compare > total ? formatMoney(compare, format) : '';
    this.ref('add').disabled = count === 0;
  }

  async #add() {
    const button = this.ref('add');
    const status = this.ref('status');
    const items = this.items
      .filter((item) => item.querySelector('[data-ref="check"]').checked)
      .map((item) => ({ id: this.#choice(item).id, quantity: 1 }));
    if (!items.length) return;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = '';
    try {
      await addItems(items);
      openCart(button);
    } catch (error) {
      status.textContent = error.message;
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }
}

define('qdz-bought-together', QdzBoughtTogether);
